import {
  setToken,
  setUserId,
  getToken,
  getUserId,
  removeToken,
  removeUserId
} from "@/utils/cookie";
import { login, userLogout } from "@/api/login";
import { Storage } from "@/utils/storage";

const state = {
  ws: null, //websocket
  token: getToken(),
  userId: Number(getUserId())
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
    setToken(token);
  },
  SET_USER_ID: (state, userId) => {
    state.userId = userId;
    setUserId(userId);
  },
  SET_WS: (state, ws) => {
    state.ws = ws;
  }
};

const actions = {
  async login({ commit }, formData) {
    const data = await login(formData);
    // 取消登陆过期
    window.TIMEOVER = false;
    const { token, userId } = data;
    commit("SET_TOKEN", token);
    commit("SET_USER_ID", userId);
    return Promise.resolve(data);
  },
  async logout({ commit }) {
    if (window.location.hostname !== "localhost") {
      await userLogout();
    }
    Storage.remove(["fm-menu", `fm-tagsView${state.userId}`]); //清除用户菜单和tagview
    sessionStorage.clear(); //清除临时缓存
    removeToken(); //清除token
    removeUserId(); //清除用户id
    commit("SET_TOKEN", "");
    commit("SET_USER_ID", "");
    commit("tagsView/SET_VIEW", [], { root: true }); //清除tagview
    commit("settings/SET_USER_INFO", {}, { root: true }); //清除用户基本信息
    state.ws && state.ws.close(); //断开用户websocket
    location.reload(); // 退出登录刷新页面，防止一些内存里的缓存引起的bug
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
